import { memo } from 'react';

import Toast from '../common/toast';

const RootLayout = () => {
	return (
		<>
			<Toast />
		</>
	);
};

export default memo(RootLayout);
